// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"6b2bbd6a","498":"18560ea7","703":"0650c06a"}[chunkId] + ".chunk.js";
};